module.exports = __webpack_public_path__ + "img/bar-arrow-right.3501fbbf.png";